import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useEnumerationAuditList from './hooks/useEnumerationAuditList';
import moment from 'moment';
import calendar1 from '../../../img/calendar1.svg';
import './RecentActivityModal.scss';
import Skeleton from '../../common/skeleton';

const RecentActivityModal = ({ show, onClose, modalTitle }) => {
  const { auditData, auditDataFetching } = useEnumerationAuditList({});
  const navigate = useNavigate();

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="Right-Model enum-activity-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="recent-activity-title">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="recent-activity-body">
        <div className="recent-activity-list">
          {auditDataFetching && (
            <>
              <Skeleton width={'100%'} height={'10rem'} />
              <Skeleton width={'100%'} height={'10rem'} />
              <Skeleton width={'100%'} height={'10rem'} />
              <Skeleton width={'100%'} height={'10rem'} />
            </>
          )}
          {!auditDataFetching &&
            auditData?.Response?.map((activity) => (
              <div className="activity-card" key={activity.oid}>
                {!!activity.createdTs && (
                  <div className="activity-date">
                    <img src={calendar1} alt="calendar button" />
                    <span>
                      {moment(activity.createdTs).format(
                        'MM/DD/YYYY, hh:mm:ss A',
                      )}
                    </span>
                  </div>
                )}

                <div className="activity-user">
                  {activity.name}
                  {activity.usertype && (
                    <span className="activity-user-role">
                      {' - '}
                      {activity.usertype}
                    </span>
                  )}
                </div>

                <div className="activity-impact">
                  {`Failed Attempt Count: ${activity.failedAttemptCount}`}
                </div>

                <div className="activity-footer">
                  <div className="activity-group">
                    <span className="label">Action Type:</span>
                    {`${activity.action}`}
                  </div>
                  <span className="footer-separator">|</span>
                  <div className="activity-type">
                    <span className="label">User Type:</span>
                    {activity.loggedinusertype}
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="divider-bottom"></div>

        <div className="recent-activity-actions">
          <Button
            variant="link"
            onClick={onClose}
            className="close-btn text-capitalize"
          >
            Close
          </Button>

          <Button
            className="view-all-btn text-capitalize"
            onClick={() => navigate(`/admin/enumeration-audit`)}
          >
            View All Activities
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RecentActivityModal;
